import React from 'react'
import Sketch from 'react-p5'
import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

const extensions = require("./extensions")

let strings = new LocalizedStrings({
    en:{
        title:"m",
        description:""
    },
    de: {
        title:"m",
        description:""
    }
});

class CircleM extends React.Component {
    constructor(props) {
        super(props)

        this.circles = 16
        this.frameNr = 0
        this.fontSize = 12
        this.animStepAngle = 1
        this.ch = "m"
        this.contamination = 0
        this.contaminationInc = 0.2
        this.disturb = []
        this.voss = null
        this.disturbancePoints = 30

        this.reset = this.reset.bind(this)
        this.setup = this.setup.bind(this)
        this.draw = this.draw.bind(this)
        this.windowResized = this.windowResized.bind(this)
    }

    componentDidMount() {
        this.props.onchangePoemInfo(strings)
    }

    disturbance(pos) {
        var p = pos*this.disturb.length
        var p1 = Math.floor(p)
        var p2 = Math.ceil(p)
        var pfrac = Math.frac(p)

        if (p1 === p2) {
            return this.disturb[p1]
        }
        if (p2 >= this.disturb.length) {
            return this.disturb[this.disturb.length-1]
        }

        return this.disturb[p1]+(this.disturb[p2]-this.disturb[p1])*pfrac
    }

    circle(p5, xpos, ypos, radius, char, contamination, letterangle, animangle) {
        var perimeter = 2*Math.PI*radius
        var charCount = Math.floor(perimeter/this.fontSize)

        if (charCount > 2) {
            for (var i = 0; i < charCount; i++) {
                var ang = (i-1)*Math.PI*2/charCount+animangle
                var distAng = Math.fmod(Math.PI*2 + ang, Math.PI*2)
                var offs = this.disturbance(Math.frac(distAng / (Math.PI*2)))

                p5.push()
                p5.translate(xpos, ypos)
                p5.rotate(ang)
                p5.translate(radius+offs*contamination, 0)
                p5.rotate(letterangle)
                p5.textAlign(p5.CENTER, p5.CENTER)
                p5.text(char, 0,0)
                p5.pop()
            }
        }
    }

    reset(p5) {
        p5.background(0)

        this.fontSize = window.innerWidth / 30

        p5.textFont("DejaVuSerif");
        p5.textSize(this.fontSize)

        this.contamination = 0
        this.disturb = []
        this.voss = new extensions.Voss()
        for (var i = 0; i < this.disturbancePoints; i++) {
            this.voss.tick()
            this.disturb[i] = 0.5-this.voss.getValue()
        }
        this.disturb[this.disturbancePoints] = this.disturb[0]
    }

    setup(p5, canvasParentRef) {
        p5.createCanvas(window.innerWidth, window.innerHeight).parent(canvasParentRef)

        this.reset(p5)
    }

    draw(p5) {
        p5.background(0)
        p5.fill(255)
        for (var i = 0; i < this.circles; i++) {
            var letterangle
            var animangle
            if ((i % 2) === 1) {
                letterangle = Math.PI
                animangle = (this.frameNr*this.animStepAngle) % 360
            }
            else {
                letterangle = 0
                animangle = -(((this.frameNr+4)*this.animStepAngle) % 360)
            }
            this.circle(p5, p5.width/2, p5.height/2, 10+i*(this.fontSize*1.1), this.ch, this.contamination, letterangle, animangle/180*Math.PI)
        }
        this.frameNr++
        this.contamination += this.contaminationInc
    }

    windowResized(p5) {
        p5.resizeCanvas(window.innerWidth, window.innerHeight)
        p5.background(0)

        this.reset(p5)
    }

    render() {
        strings.setLanguage(this.context.language)
        return <Sketch setup={this.setup} draw={this.draw} windowResized={this.windowResized} />
    }
}
CircleM.contextType = LanguageContext

export default CircleM
